export enum ItemCategoryTypes {
    Unknown = 0,
    Asset = 10,
    PlantAndTree = 20,
    Material = 30
}

export class ItemCategoryTypesArray extends Array<ItemCategoryTypes> {

    constructor(...items: ItemCategoryTypes[]) {
        super(...items);
        Object.setPrototypeOf(this, ItemCategoryTypesArray.prototype);
    }
}
